import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconCheckCircleFill from "@amzn/stencil-react-icons/icons/icon-check-circle-fill";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { getString, replacePlaceholders } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export const MessageConfirmation: FC = () => {
  return (
    <Col>
      {/* Confirmation image */}
      <Row>
        <View display="flex" justifyContent="center" width="100%" height="100%">
          <div className="cat-icon" id="confirmation-image" />
        </View>
      </Row>
      {/* Confirmation check and title */}
      <Row padding={"S500"} gridGap="S300">
        <IconCheckCircleFill color="green70" size={IconSize.Large} title={getString("orderConfirmation.success")} />
        <Text fontSize="T300" fontWeight="bold" id="confirmation-title">
          {getString("supportMessageConfirmation.confirmationTitle")}
        </Text>
      </Row>
      {/* Confirmation text */}
      <Row padding={{ left: "S500", right: "S500" }}>
        <Text id="confirmation-message">{getString("supportMessageConfirmation.confirmationText")}</Text>
      </Row>
    </Col>
  );
};
